import { useRef } from "react";

// Records when a form was first rendered (spam timing check on the server).
export function useFormStart() {
  const ref = useRef(Date.now());
  return ref;
}
